import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';
import { ContractNotifications } from './contract-notifications.model';

export interface IContractNotificationService {
  list(contractId: string): Observable<ContractNotifications>;
}

/**
 * Le journal des notifications d'un contrat, consultable par quiconque peut voir le contrat
 * (RG-notification-journal-du-contrat).
 */
@Injectable({ providedIn: 'root' })
export class ContractNotificationService implements IContractNotificationService {
  private http = inject(HttpClient);
  private url = `${inject(RUNTIME_CONFIG).apiUrl}/contracts`;

  list(contractId: string): Observable<ContractNotifications> {
    return this.http.get<ContractNotifications>(`${this.url}/${contractId}/notifications`);
  }
}
